var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{staticClass:"text-saka-grey register-hint",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('openregistration')}}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t("register-hint.lead"))+" ")]),_c('br'),_vm._v(" "+_vm._s(_vm.$t("register-hint.text"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }